



// john, sue => john and sue 
// john, sue, sally => john, sue, and sally
export function formatSequentialString(arr:any[]){
  let result:string = ""
  let midjoin:string
  let endjoin:string
  if( arr.length === 1 ) return arr[0]
  if( arr.length === 2 ) return `${arr[0]} and ${arr[1]}`
  if( arr.length > 2 ){
    midjoin = ', ';
    endjoin = ', and '
  }
  arr.forEach( (item, idx) => {
    let currjoin = (idx === arr.length - 1 ) ? endjoin : midjoin 
    result += `${item}${currjoin}`
  })
  return result
}

export function buildPolicyBlock(policy:any){
  const title = `<strong>${policy.type.charAt(0).toUpperCase()}${policy.type.substring(1)} policy:</strong>`
  const textBlock = policy.text?.length ? `<br/><span>${policy.text}</span>` : ""
  const urlBlock = policy.url?.length ? `<br/><span><a name="#">${policy.url}</a></span>` : ""
  return `<span>${title}${textBlock}${urlBlock}</span>`
}